import React, { useState } from 'react';
import styles from './Gallery.module.css';
import gallery1 from '../../assets/images/gallery_1.jpg';
import gallery2 from '../../assets/images/gallery_2.jpg';
import gallery3 from '../../assets/images/gallery_3.jpg';
import gallery4 from '../../assets/images/gallery_4.jpg';
import gallery5 from '../../assets/images/gallery_5.jpg';
import gallery6 from '../../assets/images/gallery_6.jpg';
import heroImg from '../../assets/images/gallery_5.jpg';

// eslint-disable-next-line no-unused-vars
const IMAGES = [
  { cat:'CLASSROOM',     cap:'Grooming and personality development training session', tall:true },
  { cat:'TRAINING',   cap:'In-flight service training with mock aircraft cabin', tall:false },
  { cat:'TRAINING',  cap:'Air hostess safety and emergency procedures practice', tall:true },
  { cat:'EVENTS', cap:'Graduation and certificate ceremony - Class of 2024', tall:false },
  { cat:'CLASSROOM',     cap:'Airport management operations and procedures class', tall:false },
  { cat:'TRAINING',   cap:'Customer service excellence and communication workshop', tall:true },
  { cat:'CLASSROOM',     cap:'Soft skills and grooming training session', tall:false },
  { cat:'TRAINING',  cap:'Interview preparation and confidence building workshop', tall:true },
  { cat:'ACHIEVEMENTS', cap:'Student placement celebration - Successful graduates', tall:false },
  { cat:'TRAINING',   cap:'Ground staff and passenger handling simulation', tall:false },
  { cat:'EVENTS',     cap:'Industry partnership event - Airline representatives visit', tall:true },
  { cat:'CLASSROOM',     cap:'Language and communication skills development', tall:false },
  { cat:'TRAINING',  cap:'First aid and medical training certification', tall:true },
  { cat:'CLASSROOM',   cap:'Airport security and protocols training session', tall:false },
  { cat:'ACHIEVEMENTS', cap:'Student batch photo - Certificate distribution ceremony', tall:false },
  { cat:'CLASSROOM',     cap:'Career guidance and counseling session', tall:false },
  { cat:'EVENTS',     cap:'Student networking and mentorship event 2024', tall:true },
  { cat:'TRAINING',  cap:'Practical grooming and appearance standards training', tall:false },
  { cat:'CLASSROOM',   cap:'Industry expert talks and guest lectures', tall:false },
  { cat:'ACHIEVEMENTS', cap:'Outstanding student award and recognition ceremony', tall:true },
];

const FILTERS = ['ALL','CLASSROOM','TRAINING','EVENTS','ACHIEVEMENTS'];
const PALETTES = ['#C8DCF5','#AACAF5','#90B8F0','#B8D4F8','#D0E4FF','#A0C0EC'];

const Gallery = () => {
  const [filter, setFilter] = useState('ALL');

  // If API returns no items, fall back to a small local static gallery using placeholder assets
  const STATIC_IMAGES = [
    { id: 's1', category: 'EVENTS', title: 'VINFLY Collage', caption: 'VINFLY Academy Gallery', fileUrl: gallery1, isFeatured: true },
    { id: 's2', category: 'TRAINING', title: 'Runway Moment', caption: 'Student at the runway', fileUrl: gallery2 },
    { id: 's3', category: 'TRAINING', title: 'Cockpit Session', caption: 'In-flight training cockpit', fileUrl: gallery3, isFeatured: true },
    { id: 's4', category: 'CLASSROOM', title: 'Crew Lead', caption: 'Captain mentoring students', fileUrl: gallery4 },
    { id: 's5', category: 'ACHIEVEMENTS', title: 'Over the Clouds', caption: 'Aircraft above clouds', fileUrl: gallery5 },
    { id: 's6', category: 'CLASSROOM', title: 'Terminal', caption: 'Airport terminal moments', fileUrl: gallery6 }
  ];

  // Always use local/static images only
  const sourceItems = STATIC_IMAGES;
  const visible = sourceItems.filter(img => filter === 'ALL' || img.category === filter);

  return (
    <main>
      {/* Hero */}
      <section className="page-hero" data-theme="dark" style={{ paddingBottom: '120px' }}>
        <img src={heroImg} alt="Gallery Hero" style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover', zIndex: 0 }} />
        <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', background: 'linear-gradient(to right, rgba(0,0,0,0.7), rgba(0,0,0,0.3))', zIndex: 0 }} />
        <div className="container page-hero__content">
          <p className="page-hero__breadcrumb">HOME / GALLERY</p>
          <h1 className="page-hero__title">
            <span className="page-hero__title-top" style={{ color: '#FFFFFF', opacity: 1 }}>LIFE AT</span>
            <span className="page-hero__title-bottom" style={{ color: 'var(--cyan)' }}>VIN FLY.</span>
          </h1>
          <p className="page-hero__sub">
            Real students. Real aircraft. Real stories.
          </p>
        </div>

        <div className={styles.filterBar}>
          <div className="container">
            {FILTERS.map(f => (
              <button key={f} className={`${styles.filter} ${filter===f?styles.active:''}`} onClick={()=>setFilter(f)}>{f}</button>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className={`section-py ${styles.gridSection}`}>
        <div className={`container ${styles.masonryGrid}`}>
              {visible.map((img, i) => (
                <div key={img.id} className={`${styles.gridItem} ${img.isFeatured ? styles.gridTall : ''}`}
                  style={{ 
                    background: img.fileUrl ? `url(${img.fileUrl}) center/cover no-repeat` : `linear-gradient(135deg,${PALETTES[i%6]},${PALETTES[(i+3)%6]})`,
                    minHeight: img.isFeatured ? '400px' : '250px'
                  }}>
                  <div className={styles.gridOverlay}>
                    <span className={`badge badge-filled-cyan ${styles.gridCat}`}>{img.category}</span>
                    <p className={styles.gridCap}>{img.title}: {img.caption}</p>
                  </div>
                </div>
              ))}
        </div>
      </section>

      {/* Featured Video */}
      <section className={`section-py ${styles.videoSection}`}>
        <div className="container">
          <p className="label reveal">VIDEOS</p>
          <h2 className="section-title reveal" style={{ marginTop:12, marginBottom:32 }}>Watch Our <span className="accent">Story.</span></h2>
          <div className={`${styles.videoPlayer} reveal`}>
            <div className={styles.videoPlay}>▶</div>
            <div className={styles.videoMeta}>Experience VIN Fly Academy — Student Success Stories</div>
            <div className={styles.videoDuration}>05:20</div>
          </div>
        </div>
      </section>

      {/* Instagram Strip */}
      <section className={`section-py ${styles.igSection}`}>
        <div className="container" style={{ textAlign:'center' }}>
          <p className="label reveal" style={{ justifyContent:'center', display:'flex' }}>FOLLOW OUR JOURNEY</p>
          <h2 className={`${styles.igHandle} reveal`}>@vinaviation</h2>
          <p className={`${styles.igSub} reveal`}>Latest from our classroom, training sessions, and student achievements.</p>
          <div className={`${styles.igStrip} reveal`}>
            {Array(6).fill(0).map((_,i) => (
              <div key={i} className={styles.igItem} style={{ background:`linear-gradient(135deg,${PALETTES[i]},${PALETTES[(i+2)%6]})` }}>
                <div className={styles.igHover}><span>♥</span></div>
              </div>
            ))}
          </div>
          <a href="https://www.instagram.com/vinflyaviation?igsh=MW83bjEzeW5mOWpucw==" target="_blank" rel="noreferrer" className="btn-cyan-ghost" style={{ marginTop:28 }}>FOLLOW ON INSTAGRAM →</a>
        </div>
      </section>
    </main>
  );
};

export default Gallery;
